import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.company.investment');
import { OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-company-investment',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.widget.company.investment/view.scss */
:host {
  display: block;
}

.report-page {
  background: #fff;
}

:host ::ng-deep .review-answer {
  line-height: 1.65;
  overflow-wrap: anywhere;
}

:host ::ng-deep .review-answer img {
  max-width: 100%;
  height: auto;
}

:host ::ng-deep .review-answer table {
  width: 100%;
  border-collapse: collapse;
}

:host ::ng-deep .review-answer th,
:host ::ng-deep .review-answer td {
  border: 1px solid #e4e4e7;
  padding: 6px 8px;
}

@media print {
  :host {
    display: block;
  }
  .no-print {
    display: none !important;
  }
  .report-page {
    break-inside: avoid;
    box-shadow: none !important;
    border: 1px solid #d4d4d8 !important;
  }
}`],
})
export class PortalLpsysadminWidgetCompanyInvestmentComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() company: any;
    @Input() category: any = 'investment';
    @Input() stage: any = '';

    public loading: boolean = true;
    public saving: boolean = false;
    public committee: any = null;
    public fundOptions: any[] = [];
    public activeFlow: string = 'suitability';
    public permissions: any = { can_edit_all: false, can_write_compliance: false, is_compliance_officer: false };

    public flowSteps: any[] = [
        { key: 'suitability', label: '투자적합성검증' },
        { key: 'pre', label: '예비투자심의위원회' },
        { key: 'compliance', label: '준법감시체크리스트' },
        { key: 'main', label: '투자심의위원회' },
        { key: 'invest', label: '투자' },
    ];

    public preDocuments: any[] = [
        { key: 'ir', label: 'IR 자료' },
        { key: 'report_draft', label: '투자심의보고서(초안)' },
        { key: 'term_sheet', label: 'Term sheet' },
    ];

    public complianceDocuments: any[] = [
        { key: 'compliance_checklist', label: '준법감시체크리스트' },
        { key: 'contract_draft', label: '투자계약서 초안' },
        { key: 'report_draft', label: '투자심사보고서 초안' },
    ];

    public mainDocuments: any[] = [
        { key: 'investment_report', label: '투자심의보고서' },
        { key: 'contract_draft', label: '투자계약서 초안' },
        { key: 'committee_material', label: '투자심의위원회 자료' },
        { key: 'etc', label: '기타 첨부자료' },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['stage'] && !changes['stage'].firstChange) {
            this.activeFlow = this.normalizeFlow(this.stage) || this.suggestFlow();
            await this.service.render();
        }
    }

    public async load() {
        if (!this.company?.id) {
            this.loading = false;
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call('load', { company_id: this.company.id });
        if (code === 200) {
            if (data.data.company) this.company = data.data.company;
            this.committee = data.data.committee;
            this.fundOptions = data.data.funds || [];
            this.permissions = data.data.permissions || this.permissions;
            this.ensureShape();
            this.activeFlow = this.normalizeFlow(this.stage) || this.suggestFlow();
            if (!this.normalizeFlow(this.stage)) {
                this.service.href(this.stageLink(this.activeFlow));
            }
        }
        this.loading = false;
        await this.service.render();
    }

    private normalizeFlow(value: string): string {
        const key = String(value || '').trim();
        return this.flowSteps.some((item: any) => item.key === key) ? key : '';
    }

    private ensureShape() {
        if (!this.committee.suitability) this.committee.suitability = { selected_fund_id: '', selected_fund_name: '', target_field: '', main_purpose_items: [], fund_acknowledged: false, acknowledged_at: '', memo: '' };
        if (!this.committee.pre_committee) this.committee.pre_committee = { documents: {}, members: [], result: {} };
        if (!this.committee.compliance) this.committee.compliance = { documents: {}, items: [], members: [] };
        if (!this.committee.main_committee) this.committee.main_committee = { documents: {}, members: [], result: {} };
        if (!Array.isArray(this.committee.suitability.main_purpose_items)) this.committee.suitability.main_purpose_items = [];
        if (!this.committee.review_packet) this.committee.review_packet = { documents: [], questions: [], has_data: false };
        if (!this.committee.pre_committee.documents) this.committee.pre_committee.documents = {};
        if (!this.committee.compliance.documents) this.committee.compliance.documents = {};
        if (!this.committee.main_committee.documents) this.committee.main_committee.documents = {};
        if (!this.committee.pre_committee.members) this.committee.pre_committee.members = [];
        if (!this.committee.compliance.members) this.committee.compliance.members = [];
        if (!this.committee.main_committee.members) this.committee.main_committee.members = [];
        if (!this.committee.pre_committee.result) this.committee.pre_committee.result = { open_main: 'pending', investment_opinion: 'pending', memo: '' };
        if (!this.committee.main_committee.result) this.committee.main_committee.result = { decision: 'pending', memo: '' };
        if (!this.committee.pre_committee.term_sheet_text) this.committee.pre_committee.term_sheet_text = '';
        for (const item of this.preDocuments) this.ensureDoc('pre', item.key, item.label);
        for (const item of this.complianceDocuments) this.ensureDoc('compliance', item.key, item.label);
        for (const item of this.mainDocuments) this.ensureDoc('main', item.key, item.label);
    }

    private documentsFor(section: string) {
        if (section === 'pre') return this.committee.pre_committee.documents;
        if (section === 'main') return this.committee.main_committee.documents;
        return this.committee.compliance.documents;
    }

    private ensureDoc(section: string, key: string, label: string) {
        const docs = this.documentsFor(section);
        if (!docs[key]) docs[key] = { label, url: '', name: '', updated_at: '' };
        if (!docs[key].label) docs[key].label = label;
    }

    public doc(section: string, key: string) {
        const docs = this.documentsFor(section);
        return docs[key] || { label: key, url: '', name: '' };
    }

    public payload() {
        const data: any = {
            status: this.committee.status,
            suitability: this.committee.suitability,
            pre_committee: this.committee.pre_committee,
            compliance: this.committee.compliance,
            main_committee: this.committee.main_committee,
            contract_date: this.committee.contract_date || '',
            investment_date: this.committee.investment_date || ''
        };
        const reviewQuestions = this.committee?.review_packet?.questions || [];
        if (this.committee?.review_packet?.has_data || reviewQuestions.length > 0) {
            data.review_questions = reviewQuestions;
        }
        return data;
    }

    public async save(showAlert: boolean = true): Promise<boolean> {
        if (!this.committee || !this.company?.id) return false;
        if (!this.canEditCurrentFlow()) {
            this.service.alert.error('준법감시체크리스트 작성 권한이 없습니다.');
            return false;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save', {
            company_id: this.company.id,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code === 200) {
            this.committee = data.data;
            this.ensureShape();
            if (showAlert) this.service.alert.success('저장되었습니다.');
            await this.service.render();
            return true;
        } else {
            this.service.alert.error(data?.message || '저장에 실패했습니다.');
        }
        await this.service.render();
        return false;
    }

    public async uploadDoc(section: string, key: string) {
        if (!this.canEditDocuments(section)) {
            this.service.alert.error('서류 수정 권한이 없거나 투자가 완료되었습니다.');
            return;
        }
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        const target = this.doc(section, key);
        const fd = new FormData();
        fd.append('upload', files[0]);
        this.saving = true;
        await this.service.render();
        try {
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            target.url = url;
            target.name = files[0].name;
            target.updated_at = new Date().toISOString();
            await this.save(false);
        } catch (e) {
            this.service.alert.error('파일 업로드에 실패했습니다.');
        }
        this.saving = false;
        await this.service.render();
    }

    public isInvestmentCompleted(): boolean {
        return this.committee?.status === 'executed' || this.company?.status === 'investment';
    }

    public canEditDocuments(section: string = ''): boolean {
        if (this.isInvestmentCompleted()) return false;
        if (!section) section = this.activeFlow;
        if (section === 'compliance') return this.canWriteCompliance();
        return this.canEditAll();
    }

    public selectedFund(): any {
        const fundId = this.committee?.suitability?.selected_fund_id || '';
        if (!fundId) return null;
        return this.fundOptions.find((fund: any) => fund.id === fundId) || this.committee?.suitability?.selected_fund || null;
    }

    public onSuitabilityFundChange() {
        if (!this.canEditFlow('suitability')) return;
        const fund = this.selectedFund();
        this.committee.suitability.selected_fund_name = fund?.name || '';
        this.committee.suitability.target_field = fund?.main_purpose_text || fund?.target_field || '';
        this.committee.suitability.main_purpose_items = Array.isArray(fund?.main_purpose_items) ? fund.main_purpose_items : [];
        this.committee.suitability.fund_acknowledged = false;
        this.committee.suitability.acknowledged_at = '';
        if (this.committee.status === 'suitability_checked') this.committee.status = 'draft';
        this.service.render();
    }

    public selectedFundPurposeText(): string {
        const fund = this.selectedFund();
        return this.committee?.suitability?.target_field || fund?.main_purpose_text || fund?.target_field || '';
    }

    public selectedFundPurposeItems(): any[] {
        const rows = this.committee?.suitability?.main_purpose_items;
        if (Array.isArray(rows) && rows.length > 0) return rows;
        const fundRows = this.selectedFund()?.main_purpose_items;
        return Array.isArray(fundRows) ? fundRows : [];
    }

    public purposeValue(row: any, keys: string[]): string {
        for (const key of keys) {
            const value = row?.[key];
            if (value !== undefined && value !== null && String(value).trim() !== '') return String(value);
        }
        return '-';
    }

    public fundPurposeAcknowledged(): boolean {
        return !!this.committee?.suitability?.fund_acknowledged;
    }

    public canPreProceed(): boolean {
        return !!this.committee?.suitability?.selected_fund_id && this.fundPurposeAcknowledged();
    }

    public async acknowledgeFundPurpose() {
        if (!this.canEditFlow('suitability')) {
            this.service.alert.error('투자적합성검증 수정 권한이 없습니다.');
            return;
        }
        if (!this.committee?.suitability?.selected_fund_id) {
            this.service.alert.error('투자 예정 펀드를 먼저 선택하세요.');
            return;
        }
        const fund = this.selectedFund();
        this.committee.suitability.selected_fund_name = fund?.name || this.committee.suitability.selected_fund_name || '';
        this.committee.suitability.target_field = this.selectedFundPurposeText();
        this.committee.suitability.main_purpose_items = this.selectedFundPurposeItems();
        this.committee.suitability.fund_acknowledged = true;
        this.committee.suitability.acknowledged_at = new Date().toISOString();
        if (this.committee.status === 'draft') this.committee.status = 'suitability_checked';
        const saved = await this.save(false);
        if (saved) this.service.alert.success('주목적 확인이 저장되었습니다.');
    }

    public addMember(stage: string) {
        if (!this.canManageMembers(stage)) {
            this.service.alert.error('담당자 설정 권한이 없습니다.');
            return;
        }
        if (stage === 'pre') {
            this.committee.pre_committee.members.push({ name: '', email: '', role: '예비투심위원', vote_open_main: 'pending', opinion: '' });
        } else if (stage === 'compliance') {
            this.committee.compliance.members.push({ name: '', email: '', role: '준법감시 담당자', approval: 'pending', opinion: '' });
        } else {
            this.committee.main_committee.members.push({ name: '', email: '', role: '투심위원', vote: 'pending', minutes: '' });
        }
        this.service.render();
    }

    public removeMember(stage: string, index: number) {
        if (!this.canManageMembers(stage)) {
            this.service.alert.error('담당자 설정 권한이 없습니다.');
            return;
        }
        const list = this.memberList(stage);
        list.splice(index, 1);
        this.service.render();
    }

    public addReviewQuestion() {
        if (!this.canEditAll()) {
            this.service.alert.error('추가 질의 작성 권한이 없습니다.');
            return;
        }
        if (!this.committee.review_packet) this.committee.review_packet = { documents: [], questions: [], has_data: false };
        if (!Array.isArray(this.committee.review_packet.questions)) this.committee.review_packet.questions = [];
        this.committee.review_packet.questions.push({
            id: 'q_invest_' + Date.now(),
            question: '',
            required: true,
            answer: '',
            source: 'investment_committee',
            rerequest_selected: true,
            rerequest_reason: '투자심의 과정에서 추가 확인이 필요합니다.'
        });
        this.service.render();
    }

    public removeReviewQuestion(index: number) {
        if (!this.canEditAll()) return;
        const questions = this.committee?.review_packet?.questions || [];
        questions.splice(index, 1);
        this.service.render();
    }

    public hasAnswer(value: any): boolean {
        return this.answerText(value).length > 0;
    }

    public answerText(value: any): string {
        const div = document.createElement('div');
        div.innerHTML = String(value || '');
        return (div.textContent || div.innerText || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    }

    public canEditReviewQuestion(question: any): boolean {
        return !this.hasAnswer(question?.answer);
    }

    public canRemoveReviewQuestion(question: any): boolean {
        return !this.hasAnswer(question?.answer);
    }

    public selectedReviewQuestionCount(): number {
        return (this.committee?.review_packet?.questions || []).filter((question: any) => question.rerequest_selected).length;
    }

    public pendingReviewQuestionCount(): number {
        return (this.committee?.review_packet?.questions || []).filter((question: any) => question.rerequest_status === 'pending').length;
    }

    public reviewQuestionStatusLabel(question: any): string {
        if (question?.rerequest_status === 'pending') return '답변 대기';
        if (question?.rerequest_status === 'resolved') return '답변 완료';
        if (question?.source === 'investment_committee') return '추가 질의';
        return '';
    }

    public reviewQuestionStatusClass(question: any): string {
        if (question?.rerequest_status === 'pending') return 'bg-amber-50 text-amber-700';
        if (question?.rerequest_status === 'resolved') return 'bg-emerald-50 text-emerald-700';
        return 'bg-blue-50 text-blue-700';
    }

    public async sendReviewQuestions() {
        if (!this.canEditAll()) {
            this.service.alert.error('추가 질의 발송 권한이 없습니다.');
            return;
        }
        if (!this.company?.id || !this.committee?.review_packet) return;
        if (!this.selectedReviewQuestionCount()) {
            this.service.alert.error('발송할 추가 질의를 선택하세요.');
            return;
        }
        const invalid = (this.committee.review_packet.questions || []).find((question: any) => question.rerequest_selected && !String(question.question || '').trim());
        if (invalid) {
            this.service.alert.error('추가 질의 내용을 입력하세요.');
            return;
        }
        const confirmed = await this.service.alert.show({
            title: '추가 질의 발송',
            message: `선택한 ${this.selectedReviewQuestionCount()}개 질의를 기업 담당자에게 발송하시겠습니까?`,
            cancel: '취소',
            action: '발송',
            actionBtn: 'info',
            status: 'info'
        });
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('send_review_questions', {
            company_id: this.company.id,
            data: JSON.stringify({ questions: this.committee.review_packet.questions })
        });
        this.saving = false;
        if (code === 200) {
            this.committee = data.data;
            this.ensureShape();
            this.service.alert.success('추가 질의 메일을 발송했습니다.');
        } else {
            this.service.alert.error(data?.message || '추가 질의 발송에 실패했습니다.');
        }
        await this.service.render();
    }

    public memberList(stage: string) {
        if (stage === 'pre') return this.committee.pre_committee.members;
        if (stage === 'compliance') return this.committee.compliance.members;
        return this.committee.main_committee.members;
    }

    public async sendNotice(stage: string) {
        if (!this.canSendNotice(stage)) {
            this.service.alert.error('일정 알림 발송 권한이 없습니다.');
            return;
        }
        const title = this.stageTitle(stage);
        const confirmed = await this.service.alert.show({
            title: `${title} 알림 발송`,
            message: '등록된 위원 이메일로 일정과 개별 의견 입력 링크를 발송하시겠습니까?',
            cancel: '취소',
            action: '발송',
            actionBtn: 'info',
            status: 'info'
        });
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('send_notice', {
            company_id: this.company.id,
            stage,
            category: this.category,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code === 200) {
            this.committee = data.data;
            this.ensureShape();
            this.service.alert.success(`${data.data.sent || 0}명에게 발송했습니다.`);
        } else {
            this.service.alert.error(data?.message || '알림 발송에 실패했습니다.');
        }
        await this.service.render();
    }

    public canMainProceed(): boolean {
        if (!this.canPreProceed()) return false;
        if (!this.committee?.compliance) return false;
        const docs = this.committee.compliance.documents || {};
        const docsReady = this.complianceDocuments.every((item: any) => docs[item.key]?.url);
        const checklistReady = (this.committee.compliance.items || []).filter((item: any) => item.required).every((item: any) => item.checked);
        return docsReady && checklistReady;
    }

    public async executeInvestment() {
        if (!this.canEditAll()) {
            this.service.alert.error('투자 집행 권한이 없습니다.');
            return;
        }
        const confirmed = await this.service.alert.show({
            title: '투자 집행',
            message: '투자 승인을 확정하고 기업을 투자기업으로 이동하시겠습니까?',
            cancel: '취소',
            action: '집행',
            actionBtn: 'info',
            status: 'info'
        });
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('execute_investment', {
            company_id: this.company.id,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code === 200) {
            this.committee = data.data;
            this.company.status = 'investment';
            this.category = 'investment';
            this.ensureShape();
            this.service.alert.success('투자 집행 처리가 완료되었습니다.');
            await this.service.href(`/admin/invest/company/${this.company.id}/overview`);
        } else {
            this.service.alert.error(data?.message || '투자 집행에 실패했습니다.');
        }
        await this.service.render();
    }

    public countVote(members: any[], field: string, value: string): number {
        return (members || []).filter((m: any) => m[field] === value).length;
    }

    public decisionLabel(value: string): string {
        const map: any = { pending: '미정', approve: '찬성', reject: '반대', abstain: '기권', approved: '승인', rejected: '부결', hold: '보류' };
        return map[value] || value || '미정';
    }

    public statusLabel(value: string): string {
        const map: any = {
            draft: '투자심의 작성중',
            suitability_checked: '투자적합성 확인',
            pre_notice_sent: '예비투심 알림 발송',
            compliance_notice_sent: '준법감시 알림 발송',
            main_notice_sent: '본투심 알림 발송',
            approved: '투자 승인',
            executed: '투자 집행'
        };
        return map[value] || value || '투자심의 작성중';
    }

    public statusClass(value: string): string {
        const map: any = {
            draft: 'bg-zinc-100 text-zinc-700',
            suitability_checked: 'bg-emerald-50 text-emerald-700',
            pre_notice_sent: 'bg-blue-50 text-blue-700',
            compliance_notice_sent: 'bg-amber-50 text-amber-700',
            main_notice_sent: 'bg-violet-50 text-violet-700',
            approved: 'bg-emerald-50 text-emerald-700',
            executed: 'bg-zinc-900 text-white'
        };
        return map[value] || 'bg-zinc-100 text-zinc-700';
    }

    public stageTitle(stage: string): string {
        const map: any = { suitability: '투자적합성검증', pre: '예비투자심의위원회', compliance: '준법감시체크리스트', main: '투자심의위원회', invest: '투자' };
        return map[stage] || '투자적합성검증';
    }

    public stageLink(stage: string): string {
        const map: any = {
            meeting: 'meeting_company',
            review: 'review_company',
            investment: 'company',
            exit: 'exit_company',
            dropped: 'dropped_company'
        };
        const main = map[this.category] || 'company';
        return `/admin/invest/${main}/${this.company?.id}/investment/${stage}`;
    }

    public visibleFlowSteps(): any[] {
        if (this.canEditAll()) return this.flowSteps;
        if (this.canWriteCompliance()) return this.flowSteps.filter((item: any) => item.key === 'compliance');
        return [];
    }

    public canEditAll(): boolean {
        return !!this.permissions?.can_edit_all;
    }

    public canWriteCompliance(): boolean {
        return !!this.permissions?.can_write_compliance;
    }

    public canEditFlow(flow: string = ''): boolean {
        const key = flow || this.activeFlow;
        if (key === 'compliance') return this.canWriteCompliance();
        return this.canEditAll();
    }

    public canEditCurrentFlow(): boolean {
        return this.canEditFlow(this.activeFlow);
    }

    public canManageMembers(stage: string): boolean {
        return !!stage && this.canEditAll();
    }

    public canSendNotice(stage: string): boolean {
        return !!stage && this.canEditAll() && !this.isInvestmentCompleted();
    }

    public stageState(stage: string): string {
        if (this.activeFlow === stage) return '진행중';
        if (stage === 'suitability' && !this.canPreProceed()) return '필수';
        const order: any = { suitability: 0, pre: 1, compliance: 2, main: 3, invest: 4 };
        return order[stage] < order[this.activeFlow] ? '완료/검토' : '대기';
    }

    public suggestFlow(): string {
        if (!this.committee) return 'suitability';
        if (this.committee.status === 'executed' || this.committee.main_committee?.result?.decision === 'approved') return 'invest';
        if (this.canMainProceed()) return 'main';
        if (this.committee.pre_committee?.result?.open_main === 'approved' || this.committee.status === 'compliance_notice_sent') return 'compliance';
        if (this.canPreProceed()) return 'pre';
        return 'suitability';
    }

    private numberValue(value: any): number {
        if (typeof value === 'string') {
            const match = value.replace(/,/g, '').match(/-?\d+(\.\d+)?/);
            if (!match) return 0;
            value = match[0];
        }
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    private fieldValue(source: any, keys: string[], fallback: any = ''): any {
        if (!source || typeof source !== 'object') return fallback;
        for (const key of keys) {
            if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined && source[key] !== null && source[key] !== '') {
                return source[key];
            }
        }
        return fallback;
    }

    public llmReviewResult(): any {
        return this.committee?.review_packet?.llm_review_result || {};
    }

    public llmReviewScore(): number {
        const direct = this.numberValue(this.fieldValue(this.llmReviewResult(), ['total_score', 'score', 'score_total', 'totalScore', 'total', '점수', '총점'], 0));
        if (direct > 0) return direct;
        return this.llmReviewItems().reduce((sum: number, item: any) => sum + this.numberValue(item?.score), 0);
    }

    public llmReviewMaxScore(): number {
        return this.numberValue(this.fieldValue(this.llmReviewResult(), ['max_score', 'maxScore', 'maximum_score', 'maximum', '만점'], 0));
    }

    public hasLlmReviewResult(): boolean {
        const result = this.llmReviewResult();
        return this.llmReviewMaxScore() > 0 && (!!result.generated_at || this.llmReviewItems().length > 0 || this.llmReviewScore() > 0);
    }

    public llmReviewItems(): any[] {
        const items = this.llmReviewResult()?.items;
        return Array.isArray(items) ? items : [];
    }

    public printReports() {
        window.print();
    }
}

export default PortalLpsysadminWidgetCompanyInvestmentComponent;